import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=4fd969ce&scoped=true"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
import style0 from "./submenu.vue?vue&type=style&index=0&id=4fd969ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd969ce",
  null
  
)

export default component.exports